export default __webpack_public_path__ + "static/media/hospitalbed.7652ddcc.png";